import type { TimeOfDay } from '../../lib/time-of-day'
import { Hanko } from '../Hanko'

// 錦絵の題箋に倣い、揃いものの名と、その時刻の一枚の題を縦に書く
const SERIES = '集中喫茶百景'
const TITLES: Record<TimeOfDay, string> = {
  morning: '湖霧の朝',
  day: '水鏡の昼',
  evening: '富士の夕映',
  night: '天の川の夜',
}

/** 画面の隅に貼る題箋と落款。時間帯が変わると題も替わる。絵の一部なので読み上げない */
export function Cartouche({ tod }: { tod: TimeOfDay }) {
  return (
    <div className="cartouche" aria-hidden="true" lang="ja">
      <div className="cartouche__slip">
        <span className="cartouche__series">{SERIES}</span>
        <span key={tod} className="cartouche__title">
          {TITLES[tod]}
        </span>
      </div>
      <Hanko text="灯" shape="round" size={30} className="cartouche__seal" />
    </div>
  )
}
